import React from "react";
import { Route } from "react-router-dom";
import routes from "routes";

/**
 * Render the routes belonging to one layout.
 *
 * This was copy-pasted into the admin, auth and (now deleted) rtl layouts.
 */
export const renderLayoutRoutes = (layout: string) =>
  routes
    .filter((route) => route.layout === layout)
    .map((route, key) => (
      <Route path={`/${route.path}`} element={route.component} key={key} />
    ));

/**
 * The nav title for the current path.
 *
 * The old version read window.location.href even though the layout already
 * had useLocation(), matched by substring so any prefix could win, and
 * returned a value its single caller ignored - it existed only for the
 * setState it performed as a side effect.
 *
 * Matching longest-path-first means /admin/programs/5 resolves to the
 * program detail route rather than the list it is nested under.
 */
export const getActiveRouteName = (
  pathname: string,
  layout: string,
  fallback: string
): string => {
  const match = routes
    .filter((route) => route.layout === layout)
    .map((route) => ({ route, full: `${route.layout}/${route.path}` }))
    .filter(({ route }) => {
      const base = `${route.layout}/${route.path}`.split("/:")[0];
      return pathname === base || pathname.startsWith(`${base}/`);
    })
    .sort((a, b) => b.full.length - a.full.length)[0];

  return match ? match.route.name : fallback;
};

/** Whether the path resolves to a route in this layout. */
export const isKnownRoute = (pathname: string, layout: string): boolean =>
  routes.some((route) => {
    if (route.layout !== layout) return false;
    const base = `${route.layout}/${route.path}`.split("/:")[0];
    return pathname === base || pathname.startsWith(`${base}/`);
  });
